export function getRandomGameArrayItem(array: any): number {
    return Math.floor(Math.random() * array.length);
}
